<template>
  <transition
      name="android-slide"
      v-if="popupType === 'android'"
      appear
  >
    <div
        v-if="isVisible && popupType === 'android'"
        class="install-popup"
    >
      <div class="install-popup__left">
        <div class="install-popup__logo"><img src="@/assets/images/install-popup/logo.svg?url" alt="App"/></div>
        <div class="install-popup__raiting">
          <div class="install-popup__name"><img src="@/assets/images/install-popup/TinderOne.svg?url" alt="TinderOne">
          </div>
          <div class="stars">
            <div class="star"><img src="@/assets/images/install-popup/star-full.svg?url" alt="star"></div>
            <div class="star"><img src="@/assets/images/install-popup/star-full.svg?url" alt="star"></div>
            <div class="star"><img src="@/assets/images/install-popup/star-full.svg?url" alt="star"></div>
            <div class="star"><img src="@/assets/images/install-popup/star-full.svg?url" alt="star"></div>
            <div class="star"><img src="@/assets/images/install-popup/star.svg?url" alt="star"></div>
            <span>4.5</span>
          </div>
        </div>
      </div>
      <div class="install-popup__actions">
        <span class="install-popup__actions-text">Android и IOS</span>
        <UiButton
            @click="openModal('Android')"
            :variant="'primary'"
            class="install-popup__btn"
        >
          Установить
        </UiButton>
        <span @click="closePopup" class="install-popup__close">
          <img src="@/assets/images/install-popup/close.svg?url" alt="close">
        </span>
      </div>

    </div>
  </transition>

  <transition
      name="ios-fade"
      v-else-if="popupType === 'ios'"
      appear
  >
    <div
        v-if="isVisible && popupType === 'ios'"
        class="ios-popup"
    >
      <div class="ios-popup__wrapper" v-if="!safariWarningVisible">
        <img src="@/assets/images/install-popup/warning.svg?url" alt="warning">
        <div class="ios-popup__text">
          <div class="title">Установите приложения для IOS</div>
          <div class="subtitle">Для продолжения работы установите наше приложение для IOS. Без него некоторые функции
            недоступны в браузере.
          </div>
        </div>
        <UiButton
            @click="openModal('IOS')"
            :variant="'primary'"
            class="ios-popup__btn"
        >
          Установить
        </UiButton>
      </div>
      <div v-else>
        <div class="ios-popup__wrapper">
          <img src="@/assets/images/install-popup/warning.svg?url" alt="warning">
          <div class="ios-popup__text">
            <div class="title">Внимание!</div>
            <div class="subtitle">
              Приложение не будет корректно работать. Пожалуйста, откройте сайт в Safari и добавьте его на рабочий стол
              для установки.
            </div>
          </div>
          <UiButton
              @click="openModal('IOS')"
              :variant="'primary'"
              class="ios-popup__btn"
          >
            Установить
          </UiButton>
        </div>
      </div>

    </div>
  </transition>
  <transition name="ios-fade">
    <div v-if="isVisible || showModal" class="overlay"></div>
  </transition>
  <SwipeModal v-model="showModal" no-close>
    <div class="tabs-modal">
<!--      <span class="tabs-modal__close" @click="handleClose"><img src="@/assets/images/install-popup/close-arrow.svg?url"-->
<!--                                                                alt="close"></span>-->
      <div class="tabs-modal__title">Установка приложения</div>
      <Tabs v-model="activeTab" :tabs="['IOS', 'Android']">
        <template #default="{ active }">
          <div v-if="active === 'IOS'">
            <div class="install-video">
<!--              <video-->
<!--                  src="/install_ios_fixed.mp4"-->
<!--                  muted-->
<!--                  autoplay-->
<!--                  loop-->
<!--                  playsinline-->
<!--                  webkit-playsinline-->
<!--                  preload="auto"-->
<!--              ></video>-->
              <img
                  src="/install_ios-optimize.gif"
                  alt="Установка на iOS"
                  class="install-video__gif"
              />
            </div>

            <div class="list">
              <div class="list-item">
                <div class="list-item__num">1</div>
                <div class="list-item__text">Откройте эту страницу в Safari
                  на смартфоне
                </div>
              </div>
              <div class="list-item">
                <div class="list-item__num">2</div>
                <div class="list-item__text">Нажмите “Поделиться”</div>
              </div>
              <div class="list-item">
                <div class="list-item__num">3</div>
                <div class="list-item__text">Выберите “На экран Домой”</div>
              </div>
              <div class="list-item">
                <div class="list-item__num">4</div>
                <div class="list-item__text">Нажмите “Добавить”</div>
              </div>
            </div>
<!--            <UiButton :variant="'primary'" @click="handleClose">ОК</UiButton>-->
          </div>
          <div v-else>
<!--            <video-->
<!--                class="install-video"-->
<!--                src="@/assets/video/install_android.webm?url"-->
<!--                autoplay-->
<!--                muted-->
<!--                loop-->
<!--                playsinline-->
<!--            ></video>-->
<!--            <div class="list">-->
<!--              <div class="list-item">-->
<!--                <div class="list-item__num">1</div>-->
<!--                <div class="list-item__text">Скачайте приложение на смартфон</div>-->
<!--              </div>-->
<!--              <div class="list-item">-->
<!--                <div class="list-item__num">2</div>-->
<!--                <div class="list-item__text">Установите его</div>-->
<!--              </div>-->
<!--            </div>-->
            <UiButton :variant="'primary'" @click="handleDawnload"> Перейти в Google Play</UiButton>
          </div>
        </template>
      </Tabs>
    </div>
  </SwipeModal>
</template>

<script setup lang="ts">
import {useAppInstallPopup} from '@/composables/useAppInstallPopup';
import UiButton from "../ui/UiButton.vue";
import SwipeModal from "./SwipeModal.vue";
import {onMounted, ref, watch} from "vue";
import Tabs from "../ui/Tabs.vue";

const {isVisible, popupType, markAsInstalled, closePopup, safariWarningVisible} = useAppInstallPopup();
const showModal = ref(false);

const openModal = (tab: 'IOS' | 'Android') => {
  activeTab.value = tab;
  showModal.value = true;
  markAsInstalled()
};

const handleClose = () => {
  showModal.value = false;
}

const handleDawnload = () => {
  console.log("Пользователь скачал приложение");
  window.location.href = "https://play.google.com/store/apps/details?id=com.antiiiii.tinderone&pcampaignid=web_share";
  showModal.value = false;
}

const activeTab = ref('IOS');


watch(popupType, (val) => {
  if (val === 'android') activeTab.value = 'Android';
  if (val === 'ios') activeTab.value = 'IOS';
});

onMounted(() => {
  const video = document.querySelector(".install-video video") as HTMLVideoElement | null;
  if (!video) return;

  const tryPlay = () => {
    video.play().catch(() => {});
  };

  video.addEventListener("canplay", tryPlay, { once: true });

  window.addEventListener("touchstart", () => {
    tryPlay();
  }, { once: true });
});
</script>

<style lang="scss">
.overlay {
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  position: fixed;
  z-index: 99;
  inset: 0;
}

.install-popup {
  position: fixed;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  background: #FFFFFF;
  padding: 16px 24px 16px 16px;
  max-width: 375px;
  display: flex;
  align-items: end;
  justify-content: space-between;
  width: 100%;
  color: rgba(69, 69, 69, 1);
  font-size: 16px;
  will-change: transform, opacity;

  &__close {
    width: 10px;
    height: 10px;
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
  }

  &__logo {
    width: 48px;
  }

  &__btn.btn {
    padding: 8px 16px;
    border-radius: 8px;

    .btn__label {
      font-size: 13px !important;
    }
  }

  &__name {
    height: 13px;
  }

  img {
    max-width: 100%;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 11px;
    flex: 1;
  }

  &__actions {
    flex-basis: min-content;

    &-text {
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 5px;
    }
  }

  &__raiting {
    display: flex;
    align-items: start;
    gap: 12px;
    flex-direction: column;
    height: 100%;

    .stars {
      display: flex;
      align-items: center;

      span {
        margin-left: 8px;
      }
    }

    .star {
      width: 16px;
      height: 16px;
    }
  }
}

.ios-popup {
  position: fixed;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  max-width: 320px;
  z-index: 100;
  background: #FFFFFF;
  border-radius: 32px;
  overflow: hidden;
  color: rgba(69, 69, 69, 1);
  font-size: 16px;
  line-height: 130%;
  padding: 16px;
  width: 100%;

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    text-align: center;
  }

  &__text {
    gap: 15px;
    display: flex;
    flex-direction: column;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 22px;
  }
}

.tabs-modal {
  position: relative;
  min-height: 300px;

  &__close {
    width: 30px;
    height: 30px;
    background: rgba(246, 246, 246, 1);
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .install-video {
    width: 100%;
    min-height: 170px;
    border-radius: 16px;
    overflow: hidden;

    video {
      width: 100%;
      height: auto;
    }

    img{
      max-width: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  &__title {
    color: rgba(69, 69, 69, 1);
    font-size: 28px;
    font-weight: 700;
    line-height: 35px;
    margin: 0 auto 24px;
    text-align: center;
    max-width: 60%;
  }

  .list {
    display: flex;
    align-items: start;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
    min-height: 180px;
    margin-top: 16px;
    transition: all 0.3s;
  }

  .list-item {
    display: flex;
    align-items: center;
    gap: 14px;
    color: rgba(69, 69, 69, 1);
    font-size: 16px;

    &__num {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      overflow: hidden;
      background: rgba(249, 249, 249, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bolder;
    }
  }

}

.android-slide-enter-from {
  transform: translate3d(-50%, -200%, 0);
  opacity: 0;
}

.android-slide-enter-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.android-slide-enter-to {
  transform: translate3d(-50%, 0, 0);
  opacity: 1;
}

.android-slide-leave-from {
  transform: translate3d(-50%, 0, 0);
  opacity: 1;
}

.android-slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.android-slide-leave-to {
  transform: translate3d(-50%, -200%, 0);
  opacity: 0;
}

.ios-fade-enter-from {
  opacity: 0;
}

.ios-fade-enter-active {
  transition: opacity 0.5s ease;
}

.ios-fade-enter-to {
  opacity: 1;
}

.ios-fade-leave-from {
  opacity: 1;
}

.ios-fade-leave-active {
  transition: opacity 0.3s ease;
}

.ios-fade-leave-to {
  opacity: 0;
}
</style>
